import React, { useEffect } from 'react'
import { Link, useLocation, useParams } from 'react-router-dom'
import useApi from '../../../core/customhook/useApi';

interface Responsibility {
    id: number;
    responsibility: string;
}

interface Role {
    id: number;
    role_description: string;
}

interface Skill {
    id: number;
    skill: string;
}

interface Education {
    id: number;
    qualification: string;
}

interface JobDetail {
    ID: number;
    job_title: string;
    department: string;
    job_location: string;
    experience: string;
    job_type: string;
    status: any;
    icon: string | null;
    created_date: string;
    // responsibilities: Responsibility[];
    // roles: Role[];
    // skills: Skill[];
    // education: Education[];
    job_responsibilities: string;
    educational_qualification: string;
    roles: string;
    skills: string;
    ctc: any
}

export interface JobDesResponse {
    success: boolean;
    message: string;
    statusCode: number;
    data: JobDetail;
}


const Jobdescription = () => {
    const location = useLocation()

    const {
        data: jobDesResponse,
        loading: typeLoading,
    } = useApi<JobDesResponse>("/api/job-description", {
        method: "POST",
        autoCall: true,
        payload: {
            job_id: location.state.jobId
        },
        dependencies: [location.state]
    });


    const jobResponsibilitiesHtml = jobDesResponse?.data?.job_responsibilities ?? '';
    const educationHtml = jobDesResponse?.data?.educational_qualification ?? '';
    const rolesHtml = jobDesResponse?.data?.roles ?? '';
    const skillHtml = jobDesResponse?.data?.skills ?? '';




    useEffect(() => {
        console.log("jobDesResponse?.data?.job_responsibilities", rolesHtml);

    }, [])


    return (
        <>
            {/* Page Wrapper */}
            <div className="page-wrapper">
                <div className="content">
                    <div className="card">
                        <div className="card-body p-3">
                            <div className="d-flex align-items-center justify-content-center">
                                <h2 className='text-center'>{jobDesResponse?.data.job_title} - Job Details</h2>
                            </div>
                        </div>

                    </div>
                    <div className="row">
                        <div className="card">
                            <div className="card-body">
                                <div className="d-flex flex-column mb-3">
                                    <p className="text-dark d-inline-flex align-items-center mb-2">
                                        <i className="ti ti-briefcase text-gray-5 me-2" />
                                        <strong>Job Title:</strong>
                                        <span className="ms-2">{jobDesResponse?.data.job_title}</span>
                                    </p>
                                    <p className="text-dark d-inline-flex align-items-center mb-2">
                                        <i className="ti ti-flag text-gray-5 me-2" />
                                        <strong>Department:</strong>
                                        <span className="ms-2">{jobDesResponse?.data.department}</span>
                                    </p>
                                    <p className="text-dark d-inline-flex align-items-center mb-2">
                                        <i className="ti ti-location-pin text-gray-5 me-2" />
                                        <strong>Job Location:</strong>
                                        <span className="ms-2">{jobDesResponse?.data.job_location}</span>
                                    </p>
                                    <p className="text-dark d-inline-flex align-items-center mb-2">
                                        <i className="ti ti-calendar text-gray-5 me-2" />
                                        <strong>Experience:</strong>
                                        <span className="ms-2">{jobDesResponse?.data.experience} years</span>
                                    </p>
                                    <p className="text-dark d-inline-flex align-items-center mb-2">
                                        <i className="ti ti-wallet text-gray-5 me-2" />
                                        <strong>Expected CTC:</strong>
                                        <span className="ms-2">As per Industry Norms</span>
                                    </p>
                                    <p className="text-dark d-inline-flex align-items-center mb-2">
                                        <i className="ti ti-clipboard text-gray-5 me-2" />
                                        <strong>Job Type:</strong>
                                        <span className="ms-2">{jobDesResponse?.data.job_type}</span>
                                    </p>
                                    <p className="text-dark d-inline-flex align-items-center mb-2">
                                        <i className="ti ti-clipboard text-gray-5 me-2" />
                                        <strong>Ctc:</strong>
                                        <span className="ms-2">{jobDesResponse?.data.ctc}</span>
                                    </p>
                                    <p className="text-dark d-inline-flex align-items-center mb-2">
                                        <i className="ti ti-check text-gray-5 me-2" />
                                        <strong>Status:</strong>
                                        <span className="ms-2">{jobDesResponse?.data.status == 1 ? "Active" : "Inactive"}</span>
                                    </p>
                                </div>
                                {rolesHtml && rolesHtml.trim() !== "" && (
                                    <div className="mb-3">
                                        <span className="badge text-primary-color me-1" style={{ fontSize: "16px" }}>
                                            Role Overview
                                        </span>

                                        <div
                                            className='mt-2 rendered-html'
                                            dangerouslySetInnerHTML={{ __html: rolesHtml }}
                                        />
                                    </div>
                                )}


                                <div className="mb-3">
                                    <span className="badge text-primary-color me-1" style={{ fontSize: "16px" }}>
                                        Job Responsibilities
                                    </span>


                                    <div className='mt-2'
                                        dangerouslySetInnerHTML={{ __html: jobResponsibilitiesHtml }}
                                    />





                                </div>

                                <div className="mb-3">
                                    <span className="badge text-primary-color me-1" style={{ fontSize: "16px" }}>
                                        Skills Required
                                    </span>

                                    <div className='mt-1'
                                        dangerouslySetInnerHTML={{ __html: skillHtml }}
                                    />


                                </div>

                                <div className="mb-3">
                                    <span className="badge text-primary-color me-1" style={{ fontSize: "16px" }}>
                                        Why Join Us
                                    </span>
                                    <ul style={{ fontSize: '14px', color: '#555', listStyleType: 'disc', paddingLeft: '20px' }}>
                                        <li>Be a part of a fast-growing company in the cybersecurity domain.</li>
                                        <li>Work with a highly motivated team that values innovation, performance, and professional development.</li>
                                        <li>Competitive salary package with performance incentives.</li>
                                        <li>Opportunities for growth and leadership in the IT security sales domain.</li>
                                    </ul>
                                </div>

                                <div className="mb-3">
                                    <span className="badge text-primary-color me-1" style={{ fontSize: "16px" }}>
                                        Educational Qualifications
                                    </span>

                                    <div className='mt-2'
                                        dangerouslySetInnerHTML={{ __html: educationHtml }}
                                    />

                                </div>
                            </div>
                        </div>


                    </div>
                </div>
                <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
                    <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>

                </div>
            </div>
        </>

    )
}

export default Jobdescription
